<template>
  <div class="td">
    <slot></slot>
    <div v-if="data.isAnimation" style="width: 100%;">
      <!-- 加载中…… -->
      <img :src="loading_img" alt="加载中……" style="width: 60%; margin-top: -20px" />
    </div>
    <div v-else-if="data.similar_article.length == 0" style="width: 100%;margin-top: 20px;">
      <span style="font-size: 20px;width: 100%;">暂无数据</span>
    </div>
    <div v-for="(item, index) in data.similar_article" :key="index" v-else>
      <span>
        <span
          v-for="(classItem, classIndex) in isTopClass"
          v-show="item.position == classIndex"
          :key="classIndex"
          style="
            display: inline-block;
            width: 20px;
            height: 20px;
            background: #ff8700;
            border-radius: 4px;
            margin-top: 10px;
            overflow: hidden;
            text-align: center;
            line-height: 20px;
            margin-left: 6px;
            color: #fff;
            font-size: 12px;
            float: left;
          "
        >
          {{ ranking(classIndex) }}
        </span>
        <el-tooltip :content="item.title" placement="left">
          <span
            style="
              float: right;
              width: calc(100% - 40px);
              text-align: left;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
            "
          >
            {{ item.title }}
          </span>
        </el-tooltip>
      </span>
      <span><img :src="item.avatar" /></span>
      <span>{{ item.relative_quality }}</span>
      <span>{{ item.read }}</span>
      <span>{{ item.zan }}</span>
      <span>{{ item.looking }}</span>
      <span
        @mouseenter="similarCollectionMouseEnter(item, index)"
        @mouseleave="similarCollectionMouseLeave(item, index)"
      >
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <span
              @click="similarCollectionGroup(item, index)"
              v-if="item.is_favorite == 0"
            >
              <img :src="collection" alt="收藏" v-show="similarAid != index" />
              <img :src="collected" alt="请收藏" v-show="similarAid == index" />
            </span>
            <span v-else>
              <img :src="collectioned" alt="已收藏" />
            </span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(groupItem, groupIndex) in groupListName"
              :key="groupItem.id"
            >
              <span
                @click="
                  similarcollectionedClick(item, index, groupItem, groupIndex)
                "
                >{{ groupItem.name }}</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CwSimilarTd",
  data() {
    return {
      loading_img: require('@/common/assets/loading_img.gif'),
      isAnimationIng: '',
      similarAid: -1,
      // toaken
      accessToken: "",
      // 已经收藏
      collectioned: require("@/common/assets/isCollected.png"),
      // 收藏按钮
      collection: require("@/common/assets/collection.png"),
      // 鼠标经过时候收藏按钮触发事件
      collected: require("@/common/assets/collected.png"),
      groupListName: [],
      // 头条分类
      isTopClass: [
        "头条",
        "次条",
        "三条",
        "四条",
        "五条",
        "六条",
        "七条",
        "八条",
        "八条",
      ],
    };
  },
  computed: {
    ranking() {
      return (index) => {
        let ranking = null;
        // return index
        switch (index) {
          case 1:
            ranking = "头条";
            break;
          case 2:
            ranking = "次条";
            break;
          case 3:
            ranking = "三条";
            break;
          case 4:
            ranking = "四条";
            break;
          case 5:
            ranking = "五条";
            break;
          case 6:
            ranking = "六条";
            break;
          case 7:
            ranking = "七条";
            break;
          case 8:
            ranking = "八条";
            break;
        }
        return ranking;
      };
    },
  },
  props: {
    data: {
      type: Array,
      default: () => {},
    },
  },
  // watch: {
  //   data(data) {
  //     this.isAnimationIng = data.isAnimationIng
  //     console.log(this.data)
  //   }
  // },
  created() {
    // 保存taoken
    let info = JSON.parse(localStorage.getItem("userInfo"));
    if (info) {
      this.accessToken = info.accessToken;
    }
    //  console.log(this.data);
  },
  methods: {
    // 鼠标经过时候触发
    similarCollectionMouseEnter(item, index) {
      this.similarAid = index;
      // console.log(this.data);
    },
    // 鼠标移开时候触发
    similarCollectionMouseLeave(item, index) {
      this.similarAid = null;
    },
    // 添加收藏
    similarcollectionedClick(item, index, groupItem, groupIndex) {
      // console.log(item, index, groupItem, groupIndex);
      let that = this;
      that.$http.axiosFun(
        that.$api.article_collection.favorite_article_option,
        {
          aid: item.aid,
          mid: item.mid,
          wxname: item.mp_name,
          group_id: groupItem.id,
        },
        function (res) {
          if (res.error_code == 0) {
            that.$my_message.install({
              text: `已经将文章收藏到“${groupItem.name}”分组里！！！`,
              type: "success",
            });
            location.reload();
          }
        }
      );
    },
    // 获取组列表
    similarCollectionGroup(item, index) {
      let that = this;
      // 获取组列表
      that.$http.axiosFun(
        that.$api.article_collection.collect_group_list,
        {
          type: 1,
        },
        function (res) {
          if ((res.msg = "success")) {
            that.groupListName = res.data;
            // console.log(res.data);
          }
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
          accessToken: that.accessToken,
        }
      );
    },
  },
};
</script>

<style lang="less">
.td {
  width: 100%;
  box-sizing: border-box;
  // border: solid 1px;
  height: 360px;
  overflow-x: hidden;
  div {
    width: 100%;
    // border: solid 1px rgb(247, 23, 23);
    display: flex;
    justify-content: space-around;
    span:first-child {
      width: calc(100% / 4);
    }
    span:nth-child(2) {
      img {
        height: 40px;
        width: 100px;
        border-radius: 8px;
        margin-top: calc(60px / 2 - 40px / 2);
        margin-left: calc(100% / 2 - 100px / 2);
      }
    }
    span:last-child {
      width: calc(100% / 8);
      display: inline-block;
      span {
        width: 100%;
        display: inline-block;
        display: flex;
        justify-content: space-around;
        img {
          width: 30px;
          height: 30px;
          margin-top: calc(46% / 2 - 30px / 2);
          display: inline-block;
        }
      }
    }
    span {
      text-align: center;
      line-height: 60px;
      display: inline-block;
      height: 60px;

      width: calc(100% / 8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cw-similar-td.vue